<template>
  <div class="ps-root">
    <update-site-message1/>

    <div class="ps-app">
      <!-- ۱. نوار باریک پروژه‌ها -->
      <div class="ps-submenu">
        <div class="ps-submenu-projects">
          <div
            v-for="projectItem in filteredProjects"
            :key="projectItem.id"
            class="ps-project-item"
            :class="{ active: selectedProject && selectedProject.id === projectItem.id }"
            @click="selectProject(projectItem)"
            :title="projectTitle(projectItem)"
          >
            <img
              :src="projectIcon(projectItem)"
              alt=""
              @error="onProjectIconError"
            />
            <span class="ps-project-name">{{ projectItem.name }}</span>
          </div>
        </div>

        <div class="ps-submenu-search">
          <i class="bi bi-search" style="font-size:11px;color:#888"></i>
          <input v-model="projectSearch" type="text" placeholder="جستجو..."/>
        </div>

        <button type="button" class="ps-create-btn" data-toggle="modal" data-target="#create-project-modal">
          ساخت پروژه
        </button>
      </div>

      <!-- ۲. منو -->
      <div class="ps-menu">
        <span @click="openIconsModal">آیکون</span>
        <span @click="openHeaderModal">هدر</span>
        <span data-toggle="modal" data-target="#miw-guid-modal">گاید</span>
        <span data-toggle="modal" data-target="#miw-translate-modal" @click="ensureProject">ترنسلیت</span>
        <span data-toggle="modal" data-target="#miw-domain-manager-modal" @click="ensureProject">مدیریت دامنه</span>
        <span @click="ensureProjectThen(() => $refs.loadTemplate?.pasteTemplate())">افزودن قالب</span>
        <span @click="openCssTab">استایل سراسری</span>
        <span @click="openHistoryTab">تاریخچه</span>
      </div>

      <!-- ۳. نوار ابزار -->
      <div class="ps-toolbar-top">
        <img src="../assets/logo.png" class="ps-toolbar-logo" alt="logo"/>

        <button type="button" class="ps-tool-btn" @click="ensureProjectThen(reloadSite)">
          <i class="bi bi-arrow-clockwise"></i>
          ریلود سایت
        </button>
        <button type="button" class="ps-tool-btn" @click="ensureProjectThen(openSite)">
          <i class="bi bi-box-arrow-up-right"></i>
          باز کردن سایت
        </button>
        <button type="button" class="ps-tool-btn" @click="ensureProjectThen(storeComponents)">
          <i class="bi bi-floppy"></i>
          ذخیره کردن
        </button>

        <div class="ps-build-dropdown">
          <button
            type="button"
            class="ps-tool-btn"
            @click="openBuildModal"
          >
            <i class="bi bi-cloud-upload"></i>
            بیلد کردن
          </button>
        </div>

        <button type="button" class="ps-tool-btn" @click="ensureProjectThen(setupProjectCss)">
          <i class="bi bi-gear"></i>
          ستاپ پروژه
        </button>

        <button
          type="button"
          class="ps-tool-btn"
          title="برش لایه انتخاب‌شده"
          @click="ensureProjectThen(cutSelectedLayer)"
        >
          <i class="bi bi-scissors"></i>
          برش
        </button>
        <button
          type="button"
          class="ps-tool-btn"
          title="جای‌گذاری"
          @click="pastComponentJson({ currentLayer: null, key: null, addToSelectedLayer: false })"
        >
          <i class="bi bi-clipboard-check"></i>
          جای‌گذاری
        </button>

        <div class="ps-toolbar-right-group" v-if="selectedProject">
          <div class="ps-tool-input-group">
            <select class="ps-tool-select" v-model="siteLanguage" @change="changeSiteLanguage">
              <option v-for="language in languages" :key="language.id" :value="language.slug">
                {{ language.name }}
              </option>
            </select>
            <label class="ps-tool-input-label">زبان</label>
          </div>

          <div class="ps-tool-input-group">
            <select class="ps-tool-select" v-model="sitePage">
              <optgroup label="مسیرهای سایت">
                <option
                  v-for="route in flatRouter(siteRoutesTemplateChildComputed)"
                  :key="'s-' + route.name"
                  :value="route.name"
                >{{ route.name }}</option>
              </optgroup>
              <optgroup label="مسیرهای داشبورد">
                <option
                  v-for="route in flatRouter(dashboardRoutesTemplateChild)"
                  :key="'d-' + route.name"
                  :value="route.name"
                >{{ route.name }}</option>
              </optgroup>
              <optgroup label="مسیرهای سفارشی">
                <option
                  v-for="route in findCustomRoutes()"
                  :key="'c-' + route.name"
                  :value="route.name"
                >{{ route.name }}</option>
              </optgroup>
            </select>
            <label class="ps-tool-input-label">صفحه</label>
          </div>

          <div class="ps-route-actions">
            <router-setting/>
            <create-router/>
            <delete-route/>
            <i class="bi bi-link" title="کپی لینک" @click="copyCurrentLink()"></i>
          </div>
        </div>
      </div>

      <!-- ۴. ستون چپ: دسته‌های کامپوننت -->
      <div class="ps-toolbar-left">
        <div class="ps-left-header">کامپوننت‌ها</div>
        <div
          class="ps-left-paste"
          @click="pastComponentJson({ currentLayer: null, key: null, addToSelectedLayer: false })"
        >
          <i class="bi bi-clipboard-check"></i>
          جای‌گذاری
        </div>
        <div class="ps-left-search">
          <input v-model="leftGroupSearch" type="text" placeholder="جستجوی دسته..."/>
        </div>
        <div class="ps-left-list">
          <div
            v-for="group in filteredComponentGroups"
            :key="group"
            class="ps-left-cat"
            :class="{ active: showGroupModal && activeComponentGroup === group }"
            @click="openGroupModal(group)"
          >
            <i class="bi" :class="groupIcon(group)"></i>
            <span class="ps-left-cat-name" :title="group">{{ displayGroupName(group) }}</span>
          </div>
          <div v-if="!filteredComponentGroups.length" class="text-center text-muted p-2" style="font-size:11px">
            موردی یافت نشد
          </div>
        </div>
      </div>

      <!-- ۵. بوم وسط -->
      <div class="ps-canvas">
        <!-- کارت‌های پروژه مثل طرح — وقتی پروژه‌ای انتخاب نشده -->
        <div v-if="!selectedProject" class="projects-page">
          <div class="projects-search-wrapper" @click="$refs.canvasProjectSearch?.focus()">
            <svg class="projects-search-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
            <input
              ref="canvasProjectSearch"
              type="text"
              class="projects-search-input"
              v-model="projectSearch"
              placeholder="جستجوی پروژه..."
            />
          </div>

          <div class="projects-grid">
            <div
              v-for="projectItem in filteredProjects"
              :key="'card-' + projectItem.id"
              class="project-card"
              @click="selectProject(projectItem)"
            >
              <div class="project-card-icon">
                <img
                  :src="projectIcon(projectItem)"
                  alt=""
                  @error="onProjectIconError"
                />
              </div>
              <div class="project-card-name">{{ projectItem.name }}</div>
            </div>
          </div>
        </div>

        <div v-else class="ps-page">
          <div
            v-if="useVirtualLayout"
            class="ps-layout-preview-bar"
          >
            پیش‌نمایش نهایی با SiteLayout
            <span v-if="!layoutHasRouterView">(بدون router-view — صفحه زیر لایه‌اوت آمده)</span>
          </div>
          <div class="ps-site-components" :key="'preview-' + previewEpoch">
            <template v-if="useVirtualLayout">
              <ComponentManager
                v-for="component in siteLayoutComponents()"
                :key="'layout-' + component.id + ':' + component.name"
                :component="component"
                :inject-page-components="pageComponents()"
                virtual-preview
              />
              <template v-if="!layoutHasRouterView">
                <ComponentManager
                  v-for="component in pageComponents()"
                  :key="component.id + ':' + component.name"
                  :component="component"
                />
              </template>
            </template>
            <template v-else>
              <ComponentManager
                v-for="component in pageComponents()"
                :key="component.id + ':' + component.name"
                :component="component"
              />
            </template>
          </div>
        </div>
      </div>

      <!-- ۶. سایدبار راست -->
      <div class="ps-sidebar">
        <div class="ps-sidebar-tabs">
          <button type="button" class="ps-sidebar-tab" :class="{ active: sidebarTab === 'layers' }"
                  @click="sidebarTab = 'layers'">لایه‌ها
          </button>
          <button type="button" class="ps-sidebar-tab" :class="{ active: sidebarTab === 'settings' }"
                  @click="sidebarTab = 'settings'">تنظیمات
          </button>
          <button type="button" class="ps-sidebar-tab" :class="{ active: sidebarTab === 'css' }"
                  @click="sidebarTab = 'css'">CSS
          </button>
          <button type="button" class="ps-sidebar-tab" :class="{ active: sidebarTab === 'history' }"
                  @click="openHistoryTab">تاریخچه
          </button>
        </div>

        <div class="ps-sidebar-body">
          <div v-show="sidebarTab === 'layers'" class="ps-panel">
            <div class="ps-panel-header">
              <span>لایه‌ها</span>
              <i
                class="bi bi-clipboard-check"
                title="جای‌گذاری در ریشه"
                style="cursor:pointer"
                @click="pastComponentJson({ currentLayer: null, key: null, addToSelectedLayer: false })"
              ></i>
            </div>
            <div class="ps-panel-body">
              <component-layer-manager
                v-if="selectedProject && pageComponents().length"
                :key="'layers-' + previewEpoch"
                :layers="pageComponents()"
              />
              <div v-else-if="selectedProject" class="text-center text-muted p-3" style="font-size:12px">
                لایه‌ای وجود ندارد
              </div>
              <div v-else class="text-center text-muted p-3" style="font-size:12px">
                پروژه‌ای انتخاب نشده
              </div>
            </div>
          </div>

          <div v-show="sidebarTab === 'settings'" class="ps-panel">
            <div class="ps-panel-header">تنظیمات کامپوننت</div>
            <div class="ps-panel-body component-setting">
              <div v-if="!selectedComponent || !selectedComponent.id" class="text-center text-muted p-3"
                   style="font-size:12px">
                یک لایه را انتخاب کنید
              </div>
            </div>
          </div>

          <div v-show="sidebarTab === 'css'" class="ps-panel">
            <div class="ps-panel-header">
              <span>استایل سراسری</span>
              <button type="button" class="ps-create-btn" @click="saveGlobalStyle">بیلد CSS</button>
            </div>
            <div class="ps-panel-body ps-css-panel">
              <div class="ps-css-editor-wrap">
                <textarea
                  ref="cssEditor"
                  class="ps-css-textarea"
                  dir="ltr"
                  :value="globalStyle"
                  @input="onCssInput"
                  @keydown="onCssKeydown"
                ></textarea>
                <div v-if="cssSuggestions.length" class="ps-css-suggest">
                  <div
                    v-for="(item, idx) in cssSuggestions"
                    :key="item.text + idx"
                    class="ps-css-suggest-item"
                    :class="[item.kind, { active: idx === cssSuggestIndex }]"
                    @mousedown.prevent="applyCssSuggestion(item)"
                  >
                    <span class="kind">{{ item.kind }}</span>
                    <span class="text">{{ item.text }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-show="sidebarTab === 'history'" class="ps-panel ps-history-panel">
            <div class="ps-panel-header">تاریخچه پروژه</div>
            <div class="ps-panel-body ps-history-body">
              <project-history-manager v-if="selectedProject"/>
            </div>
          </div>
        </div>
      </div>

      <!-- ۷. وضعیت -->
      <div class="ps-status">
        <div>{{ selectedProject ? selectedProject.name : 'بدون پروژه' }}</div>
        <div>{{ siteLanguage }} / {{ sitePage }}</div>
      </div>
    </div>

    <!-- مودال زیبای دسته‌بندی کامپوننت -->
    <div
      v-if="showGroupModal"
      class="ps-comp-modal-backdrop"
      @click.self="closeGroupModal"
    >
      <div class="ps-comp-modal" @click.stop>
        <div class="ps-comp-modal-header">
          <h3>{{ displayGroupName(activeComponentGroup) }}</h3>
          <button type="button" class="ps-comp-modal-close" @click="closeGroupModal">&times;</button>
        </div>
        <div class="ps-comp-modal-toolbar">
          <input v-model="componentSearch" type="text" placeholder="جستجوی کامپوننت در این دسته..."/>
        </div>
        <div class="ps-comp-modal-body">
          <div
            v-for="item in filteredLeftComponents"
            :key="item.file"
            class="ps-comp-card"
          >
            <div class="ps-comp-card-name">{{ item.name }}</div>
            <component-viewer-item
              :component-file="item.file"
              :component-object="item.component"
            />
          </div>
          <div v-if="!filteredLeftComponents.length" class="text-center text-muted p-4" style="grid-column:1/-1">
            موردی یافت نشد
          </div>
        </div>
      </div>
    </div>

    <!-- overlays خارج از گرید (فقط برای مودال‌های موجود) -->
    <div class="ps-overlays">
      <CreatProject/>
      <project-icons v-if="project" ref="projectIcons" :project="project"/>
      <translate/>
      <manual-guid/>
      <component-viewer ref="componentViewer"/>
      <load-project-template ref="loadTemplate"/>
    </div>

    <teleport to="body">
      <div class="modal fade" id="miw-header-editor-modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">هدر سایت</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <textarea
                dir="ltr"
                cols="30"
                rows="20"
                class="form-control text-left"
                v-model="headerText"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </teleport>

    <teleport to="body">
      <div class="modal fade" id="miw-domain-manager-modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">مدیریت دامنه</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="text-right">
                <domain-manager/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </teleport>

    <teleport to="body">
      <div class="modal fade" id="miw-build-site-modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">بیلد پروژه</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body text-right" dir="rtl">
              <div v-for="item in Object.keys(buildForm)" :key="item" class="custom-control custom-switch my-2">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="`miw-build-opt-${item}`"
                  v-model="buildForm[item]"
                >
                <label class="custom-control-label" :for="`miw-build-opt-${item}`">
                  {{ buildLabel(item) }}
                </label>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">بستن</button>
              <button type="button" class="btn btn-primary" @click="runBuild">اجرای بیلد</button>
            </div>
          </div>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {apiBaseUrl} from "@/main";
import {mapActions, mapGetters} from 'vuex'
import ComponentManager from "@/components/ComponentManager";
import {
  siteRoutesTemplateChild,
  dashboardRoutesTemplateChild,
  siteRoutes
} from '@moeinmdn/miw-router/src/package/routes/SiteRoutes'
import Translate from "@/components/Translations/TranslateModal";
import ComponentViewer from "@/components/ComponentViewer/ComponentViewer";
import ComponentViewerItem from "@/components/ComponentViewer/ComponentViewerItem";
import ComponentLayerManager from "@/components/ComponentLayerManager";
import ProjectIcons from "@/components/Project/ProjectIcons";
import {generateRandomString, flatRouter, findCustomRoutes} from "@/store/Modules/Site";
import "@/scss/custom.scss";
import "@/scss/photoshop-home.scss";
import UpdateSiteMessage1 from '@moeinmdn/miw-alpha-components/src/package/UpdateSiteMessage/UpdateSiteMessage1'
import ManualGuid from "@/components/ManualGuid";
import ProjectHistoryManager from "@/components/ProjectHistory/ProjectHistoryManager";
import RouterSetting from "@/components/RouterManager/RouterSetting.vue";
import CreateRouter from "@/components/RouterManager/CreateRouter.vue";
import store from "@/store";
import axios from "axios";
import $ from 'jquery'
import {getCookie} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Authentication";
import DomainManager from "@/components/DomainManager/DomainManager.vue";
import LoadProjectTemplate from "@/components/LoadProjectTemplate.vue";
import DeleteRoute from "@/components/RouterManager/DeleteRoute.vue";
import CreatProject from "@/components/Project/CreatProject.vue";
import * as miwComponents from '@moeinmdn/miw-alpha-components/src/package/IndexComponentMap'
import logoFallback from "@/assets/logo.png";

export default {
  name: 'HomeView',
  components: {
    CreatProject,
    DeleteRoute,
    LoadProjectTemplate,
    DomainManager,
    CreateRouter,
    RouterSetting,
    ProjectHistoryManager,
    ManualGuid,
    ProjectIcons,
    ComponentLayerManager,
    ComponentViewer,
    ComponentViewerItem,
    ComponentManager,
    Translate,
    UpdateSiteMessage1,
  },
  data() {
    return {
      siteRoutesTemplateChild,
      dashboardRoutesTemplateChild,
      siteRoutes,
      sitePage: 'Home',
      siteLanguage: 'fa',
      selectedProject: null,
      projectSearch: '',
      componentSearch: '',
      leftGroupSearch: '',
      sidebarTab: 'layers',
      showGroupModal: false,
      activeComponentGroup: null,
      componentsMap: {},
      cssSuggestions: [],
      cssSuggestIndex: 0,
      cssWordStart: 0,
      buildForm: {
        deploy_back: false,
        deploy_dashboard: false,
        deploy_site: true,
        deploy_site_ssr: false,
      },
      cssDictionary: [
        {text: 'display', kind: 'prop'},
        {text: 'flex', kind: 'value'},
        {text: 'grid', kind: 'value'},
        {text: 'position', kind: 'prop'},
        {text: 'absolute', kind: 'value'},
        {text: 'relative', kind: 'value'},
        {text: 'fixed', kind: 'value'},
        {text: 'color', kind: 'prop'},
        {text: 'background', kind: 'prop'},
        {text: 'background-color', kind: 'prop'},
        {text: 'font-size', kind: 'prop'},
        {text: 'font-weight', kind: 'prop'},
        {text: 'font-family', kind: 'prop'},
        {text: 'margin', kind: 'prop'},
        {text: 'padding', kind: 'prop'},
        {text: 'border', kind: 'prop'},
        {text: 'border-radius', kind: 'prop'},
        {text: 'width', kind: 'prop'},
        {text: 'height', kind: 'prop'},
        {text: 'max-width', kind: 'prop'},
        {text: 'min-height', kind: 'prop'},
        {text: 'overflow', kind: 'prop'},
        {text: 'z-index', kind: 'prop'},
        {text: 'opacity', kind: 'prop'},
        {text: 'box-shadow', kind: 'prop'},
        {text: 'transform', kind: 'prop'},
        {text: 'transition', kind: 'prop'},
        {text: 'justify-content', kind: 'prop'},
        {text: 'align-items', kind: 'prop'},
        {text: 'gap', kind: 'prop'},
        {text: 'flex-direction', kind: 'prop'},
        {text: 'text-align', kind: 'prop'},
        {text: 'direction', kind: 'prop'},
        {text: 'rtl', kind: 'value'},
        {text: 'ltr', kind: 'value'},
        {text: 'none', kind: 'value'},
        {text: 'block', kind: 'value'},
        {text: 'inline-block', kind: 'value'},
        {text: 'center', kind: 'value'},
        {text: 'space-between', kind: 'value'},
        {text: '@mixin', kind: 'at'},
        {text: '@include', kind: 'at'},
        {text: '@media', kind: 'at'},
        {text: '&:hover', kind: 'selector'},
        {text: '&:focus', kind: 'selector'},
        {text: '&:active', kind: 'selector'},
        {text: '.container', kind: 'selector'},
        {text: '.row', kind: 'selector'},
        {text: '.btn', kind: 'selector'},
      ],
    }
  },
  computed: {
    ...mapGetters({
      site: "Site/getSite",
      languages: "Language/getLanguages",
      siteInfos: "SiteInfo/getSiteInfos",
      siteTranslations: "Site/getSiteTranslations",
      siteHeader: "Site/getSiteHeader",
      projects: "ProjectAlpha/getProjects",
      project: "ProjectAlpha/getProject",
      globalStyle: 'Site/getGlobalStyle',
      getSiteSelectedLanguage: "Site/getSiteSelectedLanguage",
      getSiteSelectedPage: "Site/getSiteSelectedPage",
      selectedComponent: "Site/getSelectedComponent",
      previewEpoch: "Site/getPreviewEpoch",
    }),
    siteRoutesTemplateChildComputed() {
      let siteRoutesTemplateChildWithoutSiteLayout = Object.assign([], this.siteRoutesTemplateChild)
      let siteRouteChildCount = this.siteRoutesTemplateChild.length
      siteRoutesTemplateChildWithoutSiteLayout[siteRouteChildCount] = {
        path: '/site-layout',
        name: 'SiteLayout',
      }
      return siteRoutesTemplateChildWithoutSiteLayout
    },
    filteredProjects() {
      const list = this.projects || []
      if (!this.projectSearch) return list
      return list.filter(item => {
        const user = item.user || {}
        const ctx = `${item.name} ${user.name || ''} ${user.last_name || ''} ${user.cellphone || ''}`
        return ctx.indexOf(this.projectSearch) > -1
      })
    },
    componentGroupKeys() {
      return Object.keys(this.componentsMap)
    },
    filteredComponentGroups() {
      const keys = this.componentGroupKeys
      if (!this.leftGroupSearch) return keys
      const q = this.leftGroupSearch.toLowerCase()
      return keys.filter(g => g.toLowerCase().includes(q) || this.displayGroupName(g).toLowerCase().includes(q))
    },
    headerText: {
      get() {
        return this.siteHeader ?? ''
      },
      set(value) {
        this.$store.dispatch('Site/setSiteHeader', value)
      }
    },
    filteredLeftComponents() {
      let entries = []
      if (!this.activeComponentGroup || !this.componentsMap[this.activeComponentGroup]) {
        return []
      }
      const group = this.componentsMap[this.activeComponentGroup]
      Object.keys(group).forEach(file => {
        entries.push({
          group: this.activeComponentGroup,
          file,
          component: group[file],
          name: group[file]?.name || file,
        })
      })

      if (this.componentSearch) {
        const q = this.componentSearch.toLowerCase()
        entries = entries.filter(e =>
          e.name.toLowerCase().includes(q) ||
          e.file.toLowerCase().includes(q)
        )
      }
      return entries
    },
    useVirtualLayout() {
      return this.activeSitePage() !== 'SiteLayout' && this.siteLayoutComponents().length > 0
    },
    layoutHasRouterView() {
      return this.treeHasRouterView(this.siteLayoutComponents())
    },
  },
  methods: {
    ...mapActions({
      pastComponentJson: "Site/pastComponentJson",
      cutComponentJson: "Site/cutComponentJson",
    }),
    flatRouter,
    findCustomRoutes,
    toast,
    generateRandomString,
    projectTitle(p) {
      const user = p.user || {}
      return `${p.name} (${user.name || ''} ${user.last_name || ''})`
    },
    projectIcon(p) {
      return `${apiBaseUrl}/storage/projects/${p.id}/png.png`
    },
    onProjectIconError(e) {
      e.target.onerror = null
      e.target.src = logoFallback
    },
    selectProject(project) {
      this.selectedProject = project
      this.sidebarTab = 'layers'
    },
    ensureProject() {
      if (!this.selectedProject) {
        toast('ابتدا یک پروژه انتخاب کنید', 'ابتدا یک پروژه انتخاب کنید', 'danger')
        return false
      }
      return true
    },
    ensureProjectThen(fn) {
      if (!this.ensureProject()) return
      if (typeof fn === 'function') fn()
    },
    openSite() {
      if (this.project?.domain) {
        window.open(this.project.domain, '_blank')
      }
    },
    openIconsModal() {
      if (!this.ensureProject()) return
      this.$nextTick(() => {
        if (this.$refs.projectIcons?.openModal) {
          this.$refs.projectIcons.openModal()
        } else {
          $('#miw-project-icons-modal').modal('show')
        }
      })
    },
    openHeaderModal() {
      if (!this.ensureProject()) return
      this.$nextTick(() => {
        $('#miw-header-editor-modal').modal('show')
      })
    },
    openAddComponent() {
      if (!this.ensureProject()) return
      this.$store.dispatch('Site/setSelectedComponent', {id: '', slot: 'default'})
      toast('کامپوننت را با move اضافه کنید یا با copy بردارید و هر جا Paste کنید', 'افزودن کامپوننت')
    },
    async cutSelectedLayer() {
      const id = this.selectedComponent?.id
      if (!id) {
        toast('ابتدا یک لایه را انتخاب کنید', 'لایه‌ای انتخاب نشده', 'danger')
        return
      }
      const layer = this.findLayerById(this.pageComponents(), id)
      if (!layer) {
        toast('لایه یافت نشد', 'لایه یافت نشد', 'danger')
        return
      }
      if (!confirm('لایه انتخاب‌شده برش داده شود؟')) return
      await this.cutComponentJson(layer)
    },
    findLayerById(layers, id) {
      if (!Array.isArray(layers)) return null
      for (const layer of layers) {
        if (layer.id === id) return layer
        if (layer.slots) {
          for (const key of Object.keys(layer.slots)) {
            const found = this.findLayerById(layer.slots[key]?.components || [], id)
            if (found) return found
          }
        }
      }
      return null
    },
    openGroupModal(group) {
      this.activeComponentGroup = group
      this.componentSearch = ''
      this.showGroupModal = true
      this.$store.dispatch('Site/setSelectedComponent', {id: '', slot: 'default'})
    },
    closeGroupModal() {
      this.showGroupModal = false
    },
    displayGroupName(group) {
      if (!group) return ''
      const parts = group.split('/')
      return parts[parts.length - 1] || group
    },
    groupIcon(group) {
      const g = (group || '').toLowerCase()
      if (g.includes('nav') || g.includes('header')) return 'bi-layout-text-sidebar'
      if (g.includes('footer')) return 'bi-layout-text-window-reverse'
      if (g.includes('product')) return 'bi-bag'
      if (g.includes('cart') || g.includes('shop')) return 'bi-cart'
      if (g.includes('auth')) return 'bi-person'
      if (g.includes('slider') || g.includes('banner')) return 'bi-images'
      if (g.includes('form') || g.includes('input')) return 'bi-input-cursor-text'
      if (g.includes('card')) return 'bi-card-heading'
      if (g.includes('tag')) return 'bi-tags'
      if (g.includes('button')) return 'bi-square'
      if (g.includes('section')) return 'bi-layout-three-columns'
      return 'bi-puzzle'
    },
    buildLabel(key) {
      const map = {
        deploy_back: 'بک‌اند',
        deploy_dashboard: 'داشبورد',
        deploy_site: 'سایت',
        deploy_site_ssr: 'سایت SSR',
      }
      return map[key] || key
    },
    openBuildModal() {
      if (!this.ensureProject()) return
      this.$nextTick(() => {
        $('#miw-build-site-modal').modal('show')
      })
    },
    runBuild() {
      if (!this.ensureProject()) return
      let checker = false
      Object.keys(this.buildForm).forEach(item => {
        if (this.buildForm[item]) checker = true
      })
      if (!checker) {
        toast('حداقل یک گزینه برای بیلد باید انتخاب شده باشد.', 'حداقل یک گزینه برای بیلد باید انتخاب شده باشد.', 'danger')
        return
      }
      this.$store.dispatch('Site/buildSite', this.buildForm).then(() => {
        toast('بیلد با موفقیت در صف قرار گرفت', 'بیلد با موفقیت در صف قرار گرفت')
        $('#miw-build-site-modal').modal('hide')
      })
    },
    openCssTab() {
      if (!this.ensureProject()) return
      this.sidebarTab = 'css'
    },
    openHistoryTab() {
      if (!this.ensureProject()) return
      this.sidebarTab = 'history'
      this.$store.dispatch('ProjectHistory/setHistories')
    },
    async onCssInput(event) {
      const value = event.target.value
      await this.$store.dispatch('Site/setGlobalStyle', value)
      this.updateCssSuggestions(event.target)
    },
    updateCssSuggestions(el) {
      const pos = el.selectionStart || 0
      const before = el.value.slice(0, pos)
      const match = before.match(/([@&a-zA-Z_-][\w-]*)$/)
      if (!match || match[1].length < 1) {
        this.cssSuggestions = []
        return
      }
      const word = match[1].toLowerCase()
      this.cssWordStart = pos - match[1].length
      this.cssSuggestions = this.cssDictionary
        .filter(item => item.text.toLowerCase().startsWith(word) && item.text.toLowerCase() !== word)
        .slice(0, 8)
      this.cssSuggestIndex = 0
    },
    onCssKeydown(e) {
      if (!this.cssSuggestions.length) return
      if (e.key === 'ArrowDown') {
        e.preventDefault()
        this.cssSuggestIndex = (this.cssSuggestIndex + 1) % this.cssSuggestions.length
      } else if (e.key === 'ArrowUp') {
        e.preventDefault()
        this.cssSuggestIndex = (this.cssSuggestIndex - 1 + this.cssSuggestions.length) % this.cssSuggestions.length
      } else if (e.key === 'Enter' || e.key === 'Tab') {
        e.preventDefault()
        this.applyCssSuggestion(this.cssSuggestions[this.cssSuggestIndex])
      } else if (e.key === 'Escape') {
        this.cssSuggestions = []
      }
    },
    applyCssSuggestion(item) {
      const el = this.$refs.cssEditor
      if (!el || !item) return
      const pos = el.selectionStart || 0
      const before = el.value.slice(0, this.cssWordStart)
      const after = el.value.slice(pos)
      const next = before + item.text + after
      this.$store.dispatch('Site/setGlobalStyle', next)
      this.cssSuggestions = []
      this.$nextTick(() => {
        const caret = before.length + item.text.length
        el.focus()
        el.setSelectionRange(caret, caret)
      })
    },
    reloadSite() {
      this.$store.dispatch('ProjectAlpha/getProject', {project_id: this.selectedProject.id})
    },
    storeComponents() {
      this.$store.dispatch('Site/storeSite').then(() => {
        this.toast('ذخیره با موفقیت انجام شد', 'ذخیره با موفقیت انجام شد')
      })
    },
    changeSitePage() {
      this.$store.dispatch('Site/changeSitePage', this.sitePage)
    },
    changeSiteLanguage() {
      this.$store.dispatch('Site/changeSiteLanguage', this.siteLanguage)
    },
    async saveGlobalStyle() {
      this.toast('در حال ارسال اطلاعات', 'در حال ارسال اطلاعات')
      await this.$store.dispatch('Site/compileScss')
      await this.setupProjectCss()
    },
    async globalStyleChange(event) {
      const value = event.target.value
      await this.$store.dispatch('Site/setGlobalStyle', value)
    },
    activeSiteLanguage() {
      return this.getSiteSelectedLanguage || this.siteLanguage
    },
    activeSitePage() {
      return this.getSiteSelectedPage || this.sitePage
    },
    pageComponents() {
      try {
        const lang = this.activeSiteLanguage()
        const page = this.activeSitePage()
        if (!this.site || !this.site[lang]) return []
        const pages = this.site[lang]['pages']?.[page]
        if (pages !== undefined && pages.components) {
          return pages.components
        }
      } catch (e) {
        return []
      }
      return []
    },
    siteLayoutComponents() {
      try {
        const lang = this.activeSiteLanguage()
        if (!this.site || !this.site[lang]) return []
        const layout = this.site[lang]['pages']?.SiteLayout
        if (layout && Array.isArray(layout.components)) {
          return layout.components
        }
      } catch (e) {
        return []
      }
      return []
    },
    syncEditorPageFromStore() {
      if (this.getSiteSelectedPage && this.sitePage !== this.getSiteSelectedPage) {
        this.sitePage = this.getSiteSelectedPage
      }
      if (this.getSiteSelectedLanguage && this.siteLanguage !== this.getSiteSelectedLanguage) {
        this.siteLanguage = this.getSiteSelectedLanguage
      }
    },
    isRouterViewName(name) {
      const n = (name || '').toLowerCase()
      return n === 'm-router-view' || n === 'router-view' || n === 'm-routerview'
    },
    treeHasRouterView(layers) {
      if (!Array.isArray(layers)) return false
      for (const layer of layers) {
        if (this.isRouterViewName(layer.name)) return true
        if (layer.slots) {
          for (const key of Object.keys(layer.slots)) {
            if (this.treeHasRouterView(layer.slots[key]?.components || [])) return true
          }
        }
      }
      return false
    },
    async init() {
      let projectHistories = this.project.project_history
      let site = '{ "site": { "fa": { "pages": { "Home": { "components": [ { "id": "gvgnls6oc6hcz7tn8bp69o", "name": "m-h1", "slots": { "default": { "text": "default page", "components": [] } }, "props": {}, "css": "", "class": "text-center", "detail": { "tag": { "folder": "Tags", "name": "H1" } }, "page": "Home" } ] } }, "translations": { "site": { "name": "mixitweb", "slogan": " ---- " } }, "header": "" } }, "global_style": "" }'

      if (projectHistories && projectHistories.length) {
        site = projectHistories[0].json
      }

      if (site !== null) {
        let content = JSON.parse(site)
        await this.$store.dispatch('Site/setSite', content['site'])
        await this.$store.commit('Site/setGlobalStyle', content['global_style'])
        await this.$store.dispatch('Site/setGlobalRoutes', content)
      }

      this.setupProjectCss()
      this.sidebarTab = 'layers'
    },
    setupProjectCss() {
      const oldStyleTag = document.querySelector('[title="custom.css"]')
      if (oldStyleTag != null) {
        oldStyleTag.remove()
      }

      var head = document.head
      var link = document.createElement("link")
      const directoryProject = this.project.domain_directory + this.project.id

      link.type = "text/css"
      link.rel = "stylesheet"
      link.title = "custom.css"
      link.href = `${apiBaseUrl}/storage/projects/${directoryProject}/${this.project.id}.css?${this.generateRandomString()}`

      head.appendChild(link)
      toast('ستاپ پروژه با موفقیت انجام شد', 'ستاپ پروژه با موفقیت انجام شد')
    },
    copyCurrentLink() {
      let result = null
      let siteRoutesList = Object.assign([], this.flatRouter(this.siteRoutes))
      siteRoutesList.filter(item => {
        if (item.name == this.sitePage) {
          result = item
        }
      })

      if (result == null) {
        let customRoutes = findCustomRoutes()
        customRoutes.filter(item => {
          if (item.name == this.sitePage) {
            result = item
          }
        })
      }

      if (!result) {
        toast('مسیر یافت نشد', 'مسیر یافت نشد', 'danger')
        return
      }

      navigator.clipboard.writeText(result.path).then(() => {
        toast('کپی با موفقیت انجام شد', 'کپی با موفقیت انجام شد')
      }, (err) => {
        console.log('Copy Error => ', err)
      })
    },
    checkToken() {
      if (axios.defaults.headers.common['Authorization'] == undefined) {
        let token = localStorage.getItem('token')
        let cookieToken = getCookie('token')

        if (cookieToken != '' && token == null) {
          token = cookieToken
        }
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      }
    },
    buildComponentsMap() {
      const map = {}
      Object.keys(miwComponents).forEach(component => {
        const componentPath = miwComponents[component].path.replace('./', '')
        const parts = componentPath.split('/')
        parts.pop()
        const folder = parts.join('/')
        if (map[folder] == undefined) {
          map[folder] = {}
        }
        map[folder][component] = miwComponents[component]
      })
      this.componentsMap = map
    },
    onOpenSettings() {
      this.sidebarTab = 'settings'
    },
  },
  beforeMount() {
    document.addEventListener('keydown', e => {
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault()
        if (this.selectedProject) this.storeComponents()
      }
    })
    document.addEventListener('keydown', e => {
      if (e.ctrlKey && e.key === 'q') {
        e.preventDefault()
        if (this.selectedProject) this.saveGlobalStyle()
      }
    })
  },
  async mounted() {
    document.body.classList.add('ps-home-active')
    window.addEventListener('ps-open-settings', this.onOpenSettings)
    this.buildComponentsMap()
    await this.checkToken()
    await this.$store.dispatch('ProjectAlpha/setProjects')
  },
  beforeUnmount() {
    document.body.classList.remove('ps-home-active')
    window.removeEventListener('ps-open-settings', this.onOpenSettings)
  },
  watch: {
    siteInfos: {
      handler: function () {
        try {
          if (typeof this.findAttributeOnSiteInfo === 'function') {
            this.siteLanguage = this.findAttributeOnSiteInfo('default_language')[0].slug
            this.changeSiteLanguage()
            this.$store.commit('Site/setDefaultLanguage', this.siteLanguage)
          }
        } catch (e) {
          // ignore
        }
      },
      deep: true
    },
    selectedProject: {
      handler: function () {
        if (!this.selectedProject) return

        function setAndNotifyLocalStorage(key, value) {
          localStorage.setItem(key, value)
          var storageEvent = new Event('storageChange')
          window.dispatchEvent(storageEvent)
        }

        setAndNotifyLocalStorage('projectDomain', this.selectedProject.api_url)
        this.$store.dispatch('ProjectAlpha/getProject', {project_id: this.selectedProject.id})
        store.dispatch('SiteInfo/getSiteInfos')
        store.dispatch("Language/getLanguages")
        store.dispatch("Menu/getMenus")
      },
      deep: true
    },
    project: {
      handler: async function (newValue) {
        if (newValue != null) {
          await this.init()
          await this.$store.dispatch('ProjectHistory/setHistories')
        }
      },
      deep: true
    },
    sitePage: {
      handler: async function (newValue) {
        if (newValue != null) {
          await this.changeSitePage()
        }
      },
      deep: true
    },
    previewEpoch() {
      // بعد از لود سیو/تاریخچه، سلکت‌های لوکال را با store هم‌تراز کن
      this.$nextTick(() => this.syncEditorPageFromStore())
    },
  }
}
</script>
